import React, { Component } from "react"
import { EditDataCardContainer } from "components/editData/redux/EditDataContainers"

export class EditDataPage extends Component { render() { return (<EditDataCardContainer />) } }